import { render, staticRenderFns } from "./InvoiceReview.vue?vue&type=template&id=482021ba"
import script from "./InvoiceReview.vue?vue&type=script&lang=ts"
export * from "./InvoiceReview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports